(angular => {

  angular.module("App").filter("speakersName", [SpeakersNameFilter]);

  function SpeakersNameFilter() {
    return function(speakers) {
      const names = speakers.map(s => s.name);
      return names.join(", ");
    };
  }

})(angular);
